(function () {
  'use strict';

  function initSorscoProduct() {
    var section = document.querySelector('.sorsco-product');
    if (!section) return;

    initSwiper(section);
    initPurchaseOptions(section);
    initTabs(section);
    initTestimonialsSwiper(section);
    initTestimonialVideos(section);
  }

  /* ===================== SWIPER ===================== */

  function initSwiper(section) {
    if (typeof Swiper === 'undefined') return;

    var thumbsEl = section.querySelector('.sorsco-thumbs');
    var mainEl = section.querySelector('.sorsco-main-slider');
    if (!mainEl) return;

    var thumbsSwiper = null;
    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true
      });
    }

    var mainConfig = {
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: section.querySelector('.sorsco-nav-next'),
        prevEl: section.querySelector('.sorsco-nav-prev')
      }
    };

    if (thumbsSwiper) {
      mainConfig.thumbs = { swiper: thumbsSwiper };
    }

    new Swiper(mainEl, mainConfig);
  }

  /* ===================== PURCHASE OPTIONS ===================== */

  function initPurchaseOptions(section) {
    var purchase = section.querySelector('.sorsco-purchase');
    var onetimeOption = section.querySelector('.sorsco-purchase__option--onetime');
    var subscriptionOption = section.querySelector('.sorsco-purchase__option--subscription');
    var sellingPlanInput = section.querySelector('.sorsco-selling-plan-input');
    var variantInput = section.querySelector('.product-variant-id');
    var frequencyBtns = section.querySelectorAll('.sorsco-frequency__btn');

    var variantId = purchase ? purchase.dataset.variantId : '';

    if (!onetimeOption || !subscriptionOption) return;

    function selectOnetime() {
      onetimeOption.classList.add('active');
      subscriptionOption.classList.remove('active');
      if (variantInput) variantInput.value = variantId;
      if (sellingPlanInput) sellingPlanInput.value = '';
      if (sellingPlanInput) sellingPlanInput.removeAttribute('name');
    }

    function selectSubscription() {
      subscriptionOption.classList.add('active');
      onetimeOption.classList.remove('active');
      if (variantInput) variantInput.value = variantId;
      if (sellingPlanInput) sellingPlanInput.setAttribute('name', 'selling_plan');
      var activeFreq = section.querySelector('.sorsco-frequency__btn.active');
      if (activeFreq && sellingPlanInput) {
        sellingPlanInput.value = activeFreq.dataset.sellingPlanId;
      }
    }

    onetimeOption.addEventListener('click', function () {
      selectOnetime();
    });

    subscriptionOption.addEventListener('click', function () {
      selectSubscription();
    });

    var subPriceEl = subscriptionOption.querySelector('.sorsco-purchase__option-price-right');

    frequencyBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        frequencyBtns.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        if (sellingPlanInput && subscriptionOption.classList.contains('active')) {
          sellingPlanInput.value = this.dataset.sellingPlanId;
        }
        if (subPriceEl && this.dataset.planPrice) {
          subPriceEl.textContent = this.dataset.planPrice;
        }
      });
    });

    selectSubscription();
  }

  /* ===================== TABS ===================== */

  function initTabs(section) {
    var tabBtns = section.querySelectorAll('.sorsco-tabs__btn');
    var tabPanels = section.querySelectorAll('.sorsco-tabs__panel');

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.dataset.tab;
        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        tabPanels.forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        var panel = section.querySelector('.sorsco-tabs__panel[data-tab="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ===================== TESTIMONIALS SWIPER ===================== */

  function initTestimonialsSwiper(section) {
    if (typeof Swiper === 'undefined') return;

    var sliderEl = section.querySelector('.sorsco-testimonials-slider');
    if (!sliderEl) return;

    new Swiper(sliderEl, {
      slidesPerView: 2.3,
      spaceBetween: 4,
      freeMode: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 4,
          freeMode: false
        }
      }
    });
  }

  /* ===================== TESTIMONIAL VIDEOS ===================== */

  function initTestimonialVideos(section) {
    var allCards = section.querySelectorAll('.sorsco-testimonial-card');

    function pauseAllExcept(exceptCard) {
      allCards.forEach(function (c) {
        if (c === exceptCard) return;
        var v = c.querySelector('.sorsco-testimonial-card__video');
        if (v && !v.paused) {
          v.pause();
          c.classList.remove('is-playing');
        }
      });
    }

    allCards.forEach(function (card) {
      var playBtn = card.querySelector('.sorsco-testimonial-card__play');
      var video = card.querySelector('.sorsco-testimonial-card__video');

      if (!playBtn || !video) return;

      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        pauseAllExcept(card);
        card.classList.add('is-active');
        card.classList.add('is-playing');
        video.play();
      });

      video.addEventListener('click', function () {
        if (video.paused) {
          pauseAllExcept(card);
          card.classList.add('is-playing');
          video.play();
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', function () {
        card.classList.remove('is-active');
        card.classList.remove('is-playing');
        video.currentTime = 0;
      });
    });
  }

  /* ===================== INIT ===================== */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSorscoProduct);
  } else {
    initSorscoProduct();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.sorsco-product')) {
        initSorscoProduct();
      }
    });
  }
})();
